import { Grid, VStack } from "../../../../../styled-system/jsx";
import { css } from "../../../../../styled-system/css";
import { PageContainer } from "../../../../components/core/basic/PageContainer";
import { Badge } from "react-bootstrap";
import TodayComparisonSummary from "../../../../modules/live/components/TodayComparisonSummary";
import PerformanceByHourSection from "../../../../modules/live/components/PerformanceByHourSection";
import CampaignPerformanceSection from "../../../../modules/live/components/CampaignPerformanceSection";
import TodaysProductsSummary from "../../../../modules/live/components/TodaysProductsSummary";
import { useAppSelector } from "../../../../redux/hooks";
import { Button } from "../../../../components/core/basic/Button";
import { useNavigate, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

const LiveDashboard = () => {
  const { t } = useTranslation(["live", "common"]);
  const user = useAppSelector((state) => state.user);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const navigate = useNavigate();

  if (channel !== "amazon") {
    return (
      <PageContainer>
        <VStack gap={"medium"} justifyContent={"center"} alignItems={"center"} paddingY={"xlarge"}>
          <p>{t(($) => $.live["The live dashboard is only available for Amazon accounts."])}</p>
          <Button onPress={() => void navigate({ to: "/user/dashboard" })}>
            {t(($) => $.common.unauthorized["Return to Dashboard"])}
          </Button>
        </VStack>
      </PageContainer>
    );
  }

  if (user.organization_type !== "seller") {
    return (
      <PageContainer>
        <VStack gap={"medium"} justifyContent={"center"} alignItems={"center"} paddingY={"xlarge"}>
          <p>{t(($) => $.live["The live dashboard is only available for seller accounts."])}</p>
          <Button onPress={() => void navigate({ to: "/user/dashboard" })}>
            {t(($) => $.common.unauthorized["Return to Dashboard"])}
          </Button>
        </VStack>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <div className={css({ paddingX: "large" })}>
        <h1 className={css({ fontSize: "24px", fontWeight: "500" })}>
          {t(($) => $.live["Today"])}{" "}
          <Badge className={"badge bg-trellis-purple"} pill>
            {t(($) => $.live["Beta"])}
          </Badge>
        </h1>
        <p>
          {t(
            ($) =>
              $.live[
                "The Today page will show you realtime metrics and insights on what's happening with your products and campaign today."
              ],
          )}
        </p>
      </div>
      <Grid
        css={{ gap: "large", maxWidth: "100vw", paddingX: "large", background: "#FFF" }}
        columns={{ base: 1, lg: 2 }}
      >
        <TodayComparisonSummary />
        <PerformanceByHourSection />
        <CampaignPerformanceSection />
        <TodaysProductsSummary />
      </Grid>
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/live/report")({
  component: LiveDashboard,
});
